// state/index.ts
export * from "prosemirror-state";